import React from 'react';
import './BRoi.css'; // <-- 🩹 CIRUGÍA: Importamos el CSS modular

// Recibimos la prop 'id' que nos pasa el componente padre (BusinessLandingPage)
// y la asignamos a la <section> para que el scroll-to-section funcione.
function BRoi({ id }) {
  return (
    // 🩹 CIRUGÍA: Clase "roi-section" renombrada a "b-roi-section" para encapsular
    <section className="b-roi-section" id={id || 'roi'}>
      <div className="container">
        {/* NOTA: Las clases "section-title", "highlight-blue" y "section-subtitle" 
           son globales de la página y se quedan en BusinessLandingPage.css 
         */}
        <h2 className="section-title">
          El <span className="highlight-blue">impacto real</span> en tu empresa
        </h2>
        <p className="section-subtitle">Resultados comprobados que transforman equipos y generan ROI inmediato</p>
        
        {/* Estos estilos SÍ son locales y los moveremos a BRoi.css */}
        <div className="roi-grid">
          <div className="roi-card">
            <div className="roi-icon">📈</div>
            <div className="roi-metric">87%</div>
            <div className="roi-label">Mejora en fluidez conversacional en 6 meses</div>
          </div>
          <div className="roi-card">
            <div className="roi-icon">⏱️</div>
            <div className="roi-metric">60%</div>
            <div className="roi-label">Reducción en tiempo de capacitación vs métodos tradicionales</div>
          </div>
          <div className="roi-card">
            <div className="roi-icon">💰</div>
            <div className="roi-metric">3.5x</div>
            <div className="roi-label">ROI promedio en los primeros 12 meses</div>
          </div>
          <div className="roi-card">
            <div className="roi-icon">🎯</div>
            <div className="roi-metric">92%</div>
            <div className="roi-label">Tasa de completación de programas corporativos</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BRoi;

